<!--
 * @Autor: 
 * @Description: 为你推荐
 * @Date: 2021-07-15 15:46:25
 * @LastEditors: chenzel
 * @LastEditTime: 2021-09-23 17:58:24
-->
<template>
  <div v-show="showModule" class="new-goods-list">
    <div v-if="timeAxisList.length > 0" class="header-text">
      <span v-if="timeAxisList[0]" :class="{active: tabType === 1}" @click="changeTab(1)">主推新品</span>
    </div>
    <div v-if="newGoodsList.length > 0" class="new-goods-list-container">
      <new-good-card
        v-for="(item, index) in newGoodsList"
        :key="item.itemId"
        class="item-container-new" 
        :itemData="item"
        :index="index"
        @toDetail="toDetail"
      />
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import * as service from '@/pages/commodity/api/category-new'
import YunJi from '@/assets/js/YunJi'
import GoodCard from './GoodCard.vue'
import NewGoodCard from './NewGoodCard.vue'
import { jumpHandle } from '../util'
import * as MarkeUtil from '@/pages/commodity/common/MarkeLabelUtil'

const { mapState, mapMutations } = createNamespacedHelpers('categoryNav')

export default {
  name: 'new-goods-list',
  components: {
    GoodCard,
    NewGoodCard
  },
  data() {
    return {
      timeAxisList: [],
      tabType: 1, // 1-今日轴，2-明日轴
      newGoodsList: [],
      allLoaded: false,
      showModule: false,
      appCont: YunJi.getUrlParams('appCont') || 0
    }
  },
  watch: {
    showModule(newV) {
      this.SETNEWGOODRREQ(newV ? 0 : 3)
    }
  },
  mounted() {
    this.queryTimesAxisTabs()
  },
  beforeDestroy() {
    const contentIdList = []
    this.newGoodsList.forEach((item) => {
      contentIdList.push(`ITM_${item.itemId}`)
    })
    
    // 【新品】99新品离开曝光
    window.thinkingReport.track('exposure', {
      page_id: 10294,
      point_id: 28618,
      content_type: '离开曝光',
      content_id: contentIdList.join(','),
      tab_name: this.parentLevelName,
      index: this.newGoodsList.length,
      module_name: '99新品'
    })
  },
  computed: {
    ...mapState(['parentLevelName', 'shopId'])
  },
  methods: {
    ...mapMutations(['SETNEWGOODRREQ']),
    queryTimesAxisTabs() {
      const params = {
        appCont: 0,
        userType: 0,
        requestSource: 2
      }
      service.queryTimesAxisTabs(params).then((res) => {
        if (res.errorCode === 0) {
          this.timeAxisList = res.data ? res.data.activityTimesList || [] : []
          if (this.timeAxisList.length > 0) {
            this.queryCategoryNewItemTabAxisItems()
          }
        }
      })
    },
    queryCategoryNewItemTabAxisItems() {
      const params = {
        appCont: this.appCont,
        tabType: this.tabType
      }
      this.newGoodsList = []
      service.queryCategoryNewItemTabAxisItems(params).then((res) => {
        if (res.errorCode === 0) {
          const tempArr = res.data || []
          // 新品小于1时隐藏
          if (tempArr.length < 1) {
            this.showModule = false
            return
          }
          this.showModule = true
          const arr2 = [] // 大图一列式主推商品
          for (const item of tempArr) {
            // newItemRecommend是否主推新品 0否1是
            if (item.timesAxisItemBo.newItemRecommend === 1) arr2.push(item.timesAxisItemBo)
          }
          this.newGoodsList = MarkeUtil.setMarkeLabelByItemsListNew(arr2, false, this.appCont, 1)
        } else {
          this.showModule = false
        }
      })
    },
    changeTab(val) {
      // 【新品】99新品-TAB点击
      window.thinkingReport.track('click_list', {
        page_id: 10294,
        point_id: 28617,
        guide_type: val === 1 ? '今日' : '预告',
        tab_name: this.parentLevelName,
        module_name: '99新品'
      })
      this.tabType = val
      this.queryCategoryNewItemTabAxisItems()
    },
    toDetail(jumpData) {
      const guideType = this.tabType === 1 ? '今日' : '预告'
      // 普通新品的index在主推新品基础上加
      const index = jumpData.goodType ? jumpData.index + this.newGoodsList.length + 1 : jumpData.index + 1
      // 【新品】99新品商品点击
      window.thinkingReport.track('click_list', {
        page_id: 10294,
        point_id: 28616,
        click_type: jumpData.clickType,
        content_type: '商品',
        guide_type: guideType,
        tab_name: this.parentLevelName,
        index,
        module_name: '99新品'
      })
      jumpData.appCont = this.appCont
      jumpData.shopId = this.shopId
      jumpHandle(jumpData, this.appCont)
    }
  }
}
</script>
<style lang="less" scoped>
.new-goods-list {
  width: 100%;
  background-color: #fff;
  border-radius: .08rem;
  padding-bottom: .06rem;
  .header-text {
    padding: .3rem .16rem .22rem .16rem;
    font-family: PingFangSC-Semibold;
    font-size: .28rem;
    color: #262626;
    display: flex;
    align-items: center;
    img {
      width: .32rem;
      height: .32rem;
      margin-right: .12rem;
    }
    span:first-child {
      margin-right: .44rem;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: .26rem;
      color: #666666;
    }
    .active {
      font-size: .28rem;
      color: #262626;
      font-weight: bold;
    }
  }
  .recommend-list-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .item-container {
    margin: .08rem 0;
  }
  .item-container-new {
    width: 100%;
    margin-bottom: .16rem;
    display: flex;
    flex: 1;
    position: relative;
    z-index: 2;
    &:last-child{
      margin-bottom: .08rem;
    }
    &::after{
      border: 1px solid #E6E6E6;
      content: '';
      position: absolute;
      width: 200%;
      height: 200%;
      border-radius: .08rem;
      -webkit-transform-origin: 0 0;
      -moz-transform-origin: 0 0;
      -ms-transform-origin: 0 0;
      -o-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-transform: scale(0.5, 0.5);
      -ms-transform: scale(0.5, 0.5);
      -o-transform: scale(0.5, 0.5);
      transform: scale(0.5, 0.5);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      z-index: 1;
    }
  }
  .new-goods-list-container {
    // margin: 0 .07rem;
    padding: 0 .16rem;
    display: flex;
    flex-direction: column;
  }
}
</style>
